<figure
  class="card-training"
  role="button"
  (click)="buttonClick.emit(content?.id ?? null)"
>
  <img class="card-training__image" alt="" [src]="content?.image" />
  <figcaption class="card-training__caption">
    <div class="card-training__caption__content">
      <strong class="p">{{ content?.text }}</strong>
    </div>
    <footer class="card-training__caption__footer">
      <p>
        {{
          content?.date
            ? 'Disponível até ' + (content?.date | date: 'dd/MM/yyyy')
            : 'Disponível por tempo indeterminado'
        }}
      </p>
    </footer>
  </figcaption>
</figure>

